<template>
  <div class="mb-5 flex basis-full items-stretch lg:mb-0 lg:basis-4/12">
    <div class="rounded bg-white px-5 py-4 shadow">
      <img
        class="mx-auto mb-4 w-full"
        src="~/assets/images/Te/TeCommon/MentorSupport/Mentoring/ill-mentor-support-mentoring.svg"
        alt="マンツーマンメンタリング"
        width="339"
        height="191"
        loading="lazy"
      >
      <h2
        class="co-display-10 mb-2 text-center font-bold"
      >
        <slot name="title">
          週2回の
          <br>
          マンツーマンメンタリング
        </slot>
      </h2>
      <p class="mb-4">
        <slot name="lead">
          1回30分のビデオチャットで実施し、質問や相談などにパーソナルメンターがお答えします。
        </slot>
      </p>
      <p class="co-display-13 text-co-gray-500">
        <slot name="annotation">
          ※最初の週のみメンタリングは週1回
        </slot>
      </p>
    </div>
  </div>
</template>
